import { shallowRef } from "vue";

/** Utility composable to extract the map instance from a GoogleMap component.
 * The attrs must be binded to the GoogleMap instance
 *
 * ```vue
 * <GoogleMap v-bind="attrs" />
 * ```
 */
export function useExposedMap() {
	const map = shallowRef<google.maps.Map | undefined>();

	const attrs = {
		onReady: (m: google.maps.Map) => (map.value = m),
	};

	return {
		map,
		attrs,
	};
}
